module.exports = __webpack_public_path__ + "static/img/huaiSpecial.c1a5f6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/huaiSpecial.png
// module id = ZngO
// module chunks = 0